<!--新建固件-->
<template>
  <el-dialog
    title="新建固件"
    :visible.sync="dialogVisible"
    width="628px"
    :before-close="handleClose"
    :close-on-click-modal="false">
    <el-form ref="form" :rules="rules" :model="form" label-width="170px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="固件名称" prop="name">
            <template #label>
              <span>固件名称</span>&nbsp;
              <el-tooltip content="仅用于管理固件，不对外显示" placement="top">
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-input
              v-model="form.name"
              class="name-input"
              maxlength="32"
              show-word-limit
              placeholder="请输入固件名称"></el-input>
          </el-form-item>
          <el-form-item label="固件类型" prop="type">
            <template #label>
              <span>固件类型</span>&nbsp;
              <el-tooltip placement="top">
                <template #content>
                  <p>①MCU SDK开发上传MCU固件时建议选择MCU固件;</p>
                  <p>②其他开发方式，主通讯固件请选择'模组固件;</p>
                  <p>③如果模组固件被占用，可以根据自己模组通讯类型选择;</p>
                  <p>④如果固件类型置灰不可选，请查看是否有相同类型的固件;</p>
                </template>
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-select v-model="form.type" placeholder="请选择">
              <el-option
                v-for="item in firmwareTypeOptions"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="升级通道号" prop="upgradeChannel">
            <template #label>
              <span>升级通道号</span>&nbsp;
              <el-tooltip placement="top">
                <template #content>
                  用于固件OTA对应升级，需要将通道号写入固件。(固件类型为模组固件、蓝牙固件、Zigbee固件、MCU固件已经写好)
                </template>
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-select v-model="form.upgradeChannel" placeholder="请选择">
              <el-option
                v-for="item in upgradeChannelOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="自定义编号" prop="customNumbering">
            <template #label>
              <span>自定义编号</span>&nbsp;
              <el-tooltip placement="top">
                <template #content>
                  用于集中器等同一个PID设备内由于接入设备品牌不一致需要不同固件的设备使用，可不填。不填则根据默认方式进行填充。默认为0，即为常规通道
                </template>
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-input
              v-model="form.customNumbering"
              placeholder="请输入自定义编号"></el-input>
          </el-form-item>
          <el-form-item label="固件升级超时时间" prop="timeoutTime">
            <template #label>
              <span>固件升级超时时间</span>&nbsp;
              <el-tooltip content="用于规定OTA等待时间，超时判定为升级失败，可根据固件包大小和用户体验适当调整" placement="top">
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-input v-model="form.timeoutTime" type="number" max="1800" min="1" placeholder="请输入1~1800">
              <template slot="append">秒</template>
            </el-input>
          </el-form-item>
          <el-form-item label="单次间隔升级超时时间" prop="singleTimeout">
            <el-input v-model="form.singleTimeout" type="number" max="1800" min="1" placeholder="请输入1~1800">
              <template slot="append">秒</template>
            </el-input>
          </el-form-item>
          <el-form-item label="备注说明" prop="remarks">
            <el-input
              v-model="form.remarks"
              type="textarea"
              maxlength="200"
              show-word-limit
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="固件版本" prop="version">
            <template #label>
              <span>固件版本</span>&nbsp;
              <el-tooltip placement="top">
                <template #content>
                  <p>①版本号根据 小数点(.) 分割，转成int 数组，依次顺序比较数组里的 int数字，数字大则版本号大;</p>
                  <p>②若数组的int数字均相同，则比较两个数组的长度，长度长的版本号大长度也相等的则两个版本号相等;</p>
                </template>
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-input
              v-model="form.version"
              class="name-input"
              maxlength="32"
              show-word-limit
              placeholder="版本号格式为xx.xx.xx，如1.0.0"></el-input>
          </el-form-item>
          <el-form-item label="关键版本" prop="criticalVersionFlag">
            <template #label>
              <span>关键版本</span>&nbsp;
              <el-tooltip content="内容同原创建新固件中“关键版本为不可越过的版本，即当设定某个版本为关键版本后，即使发布了新的固件老固件也必须升级为关键版本，才可继续升级为最新版本" placement="top">
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-radio-group v-model="form.criticalVersionFlag">
              <!-- <el-radio :label="true">是</el-radio> -->
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="固件包" prop="package">
            <template #label>
              <span>固件包</span>&nbsp;
              <el-tooltip placement="top">
                <template #content>
                  <p>一般用于固件升级（OTA）的固件文件</p>
                  <p>全量升级类型的升级包上传不需要填写支持版本，其他类的升级包请务必填写支持设备版本</p>
                </template>
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-upload
              ref="firmwareUpload"
              class="upload-demo"
              action="#"
              :before-upload="beforeUpload"
              :on-error="uploadError"
              :on-exceed="handleExceed"
              :http-request="onHttpRequest"
              :limit="1"
              :disabled="isUploading"
              :file-list="fileList"
              :show-file-list="false">
              <el-button size="small" icon="el-icon-plus" :loading="isUploading" :disabled="isUploading">
                {{ uploadBtnText }}
              </el-button>
            </el-upload>

            <!-- 上传中 -->
            <div v-if="isUploading" class="upload-status-line">
              <div class="upload-status-text">
                <span class="upload-package-name" :title="uploadFileName">包名：{{ uploadFileName }}</span>
                <span v-if="statusText" class="upload-status-step">{{ statusText }}</span>
              </div>
              <div class="upload-progress-row">
                <el-progress
                  class="upload-progress-bar"
                  :percentage="uploadPercentage"
                  :stroke-width="6"
                  :show-text="false"
                  color="#275fe8">
                </el-progress>
                <span class="upload-progress-percent">{{ uploadPercentage }}%</span>
                <i
                  class="el-icon-close upload-cancel-icon"
                  title="取消上传"
                  @click="cancelUpload">
                </i>
              </div>
            </div>

            <!-- 上传结束：包名 + 成功/失败标记 -->
            <div v-else-if="uploadFileName" class="upload-result-line">
              <span class="upload-result-name" :title="uploadFileName">包名：{{ uploadFileName }}</span>
              <i v-if="uploadResult === 'success'" class="el-icon-success upload-result-icon success"></i>
              <i v-else-if="uploadResult === 'error'" class="el-icon-error upload-result-icon error"></i>
            </div>
          </el-form-item>
          <el-form-item label="版本说明" prop="description">
            <el-input
              v-model="form.description"
              type="textarea"
              maxlength="200"
              show-word-limit
              placeholder="请输入适当说明信息"></el-input>
          </el-form-item>
          <el-form-item label="是否上架" prop="isListed">
            <template #label>
              <span>是否上架</span>&nbsp;
              <el-tooltip content="上架操作后，才能进行固件升级和产品发布。选择上架则默认使用范围为“不限范围”" placement="top">
                <i class="iconfont icon-wenhao"></i>
              </el-tooltip>
            </template>
            <el-radio-group v-model="form.isListed">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="14" @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        size="14"
        :loading="!!uploadLoading"
        :disabled="!canSubmit"
        @click="handleSubmit">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import { firmwareType, addFirmware } from "@/api/product/firmware"
import store from '@/store'
import { uploadFileToOBS } from "@/util/obs"

export default {
  name: "addFirmwareDialog",
  props: {
    pageType: {
      type: String,
      default: 'firmwareManage' // firmwareManage 固件管理 firmwareDetails 固件详情
    },
    queryFirmwareManageList: {
      type: Function,
      default: () => {} // 一个空函数，避免子组件调用时报错
    },
    getFirmwareList: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    const validatePackage = (rule, value, callback) => {
      if (this.uploadResult !== 'success' || this.fileList.length === 0) {
        callback(new Error('请上传固件'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false, // 弹窗是否显示
      formValid: false, // 表单静默校验是否通过
      fileList: [], // 上传的固件文件
      uploadSuccessOrError: false, // 上传成功标记（表单校验用）
      uploadResult: '', // success | error
      uploadFileName: '', // 已选/已传文件名
      firmwarePackage: {}, // 上传成功的固件包信息
      uploadLoading: false, // 保存提交中
      uploadPercentage: 0, // 整体上传进度 0~100（MD5+分片连续递增）
      isUploading: false, // 是否正在上传
      uploadAbortController: null, // 取消上传控制器
      uploadCancelNotified: false, // 取消提示是否已弹出（防重复）
      headerObj: {
        'TENANT-ID': store.getters.userInfo.tenantId,
        Authorization: 'Bearer ' + store.getters.access_token
      },
      firmwareTypeOptions: [], // 固件类型选项
      form: {
        name: '', // 固件名称
        type: '', // 固件类型
        upgradeChannel: '', // 升级通道号
        customNumbering: 0, // 自定义编号
        timeoutTime: '', // 固件升级超时时间
        singleTimeout: '', // 单次间隔升级超时时间
        remarks: '', // 备注说明
        version: '', // 固件版本
        criticalVersionFlag: false, // 关键版本
        package: '', // 固件包
        description: '', // 版本说明
        isListed: true, // 是否上架
        productId: this.$route.query.productId
      },
      // 生成1到180的数字数组作为选项
      upgradeChannelOptions: Array.from({ length: 180 }, (_, index) => index + 1),
      rules: {
        package: { required: true, validator: validatePackage, trigger: 'change' },
        name: [
          { required: true, message: '请输入固件名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择固件类型', trigger: 'change' }
        ],
        upgradeChannel: [
          { required: true, message: '请选择升级通道号', trigger: 'change' }
        ],
        timeoutTime: [
          { required: true, message: '请输入固件升级超时时间', trigger: 'blur' },
          { validator: this.validateTimeoutTime, trigger: 'blur' }
        ],
        singleTimeout: [
          { required: true, message: '请输入单次间隔升级超时时间', trigger: 'blur' },
          { validator: this.validateSingleTimeout, trigger: 'blur' }
        ],
        version: [
          { required: true, message: '请输入固件版本', trigger: 'blur' }
        ],
        isListed: [
          { required: true, message: '请选择是否上架', trigger: 'change' }
        ]
      },
      statusText: '' // 上传状态的文本
    }
  },
  computed: {
    uploadBtnText() {
      if (this.isUploading) return '正在上传中'
      if (this.uploadFileName) return '重新上传'
      return '上传固件'
    },
    // 表单校验通过，且非上传/提交中，才允许保存
    canSubmit() {
      return this.formValid && !this.isUploading && !this.uploadLoading
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.checkFormValid()
      }
    },
    fileList() {
      this.checkFormValid()
    },
    uploadResult() {
      this.checkFormValid()
    },
    dialogVisible(val) {
      if (val) {
        this.formValid = false
        this.$nextTick(() => this.checkFormValid())
      }
    }
  },
  created() {
    this.getFirmwareType()
  },
  methods: {
    // 静默跑一遍 Element 表单校验，只更新 formValid，不常驻展示错误
    checkFormValid() {
      this.$nextTick(() => {
        const form = this.$refs.form
        if (!form || !this.dialogVisible) {
          this.formValid = false
          return
        }
        form.validate((valid) => {
          this.formValid = !!valid
          form.clearValidate()
        })
      })
    },
    // 固件升级超时时间校验提示
    validateTimeoutTime(rule, value, callback) {
      const regex = /^(?:1[0-7]\d{2}|1800|[1-9]\d{0,2})$/
      if (!regex.test(value)) {
        callback(new Error('请输入正确的固件升级超时时间'))
      } else {
        callback()
      }
    },
    // 单次超时时长校验提示
    validateSingleTimeout(rule, value, callback) {
      const regex = /^(?:1[0-7]\d{2}|1800|[1-9]\d{0,2})$/
      if (!regex.test(value)) {
        callback(new Error('请输入正确的单次间隔升级超时时间'))
      } else {
        callback()
      }
    },
    // 获取固件类型
    getFirmwareType() {
      firmwareType().then(res => {
        this.firmwareTypeOptions = res.data.data
      }).catch(err => {
        this.$message.error(err || '请求异常')
      })
    },
    // // 字节单位转换为m
    // bytesToMegabytes(bytes) {
    //   const megabytes = parseInt(bytes) / (1024 * 1024)
    //   return megabytes.toFixed(4) + 'M'
    // },
    // 只能上传一个固件，超过替换
    handleChange(file, fileList) {
      // this.fileList = [file];
    },
    // 固件上传前的校验
    beforeUpload(file) {
      if (file.name && file.name.includes(' ')) {
        this.$message.error('包名输入错误，请重新上传')
        return false
      }
      return true
    },
    // 已有文件时再次选择，覆盖上传
    handleExceed(files) {
      const upload = this.$refs.firmwareUpload
      if (!upload || !files || !files.length) return

      // 取消进行中的上传（静默，不弹「上传已取消」）
      if (this.isUploading && this.uploadAbortController) {
        this.uploadCancelNotified = true
        this.uploadAbortController.abort()
        this.uploadAbortController = null
      }

      upload.clearFiles()
      this.fileList = []
      this.uploadSuccessOrError = false
      this.uploadResult = ''
      this.uploadFileName = ''
      this.firmwarePackage = {}

      const rawFile = files[0]
      // Element UI：清空后手动加入并提交，实现覆盖上传
      this.$nextTick(() => {
        upload.handleStart(rawFile)
        upload.submit()
      })
    },
    // 取消当前上传（先立刻刷新 UI，再中断后台任务）
    cancelUpload() {
      if (!this.isUploading) return

      if (!this.uploadCancelNotified) {
        this.uploadCancelNotified = true
        this.$message.info('上传已取消')
      }

      // 立即结束上传中状态，避免等 Promise reject 才有反应
      this.isUploading = false
      this.uploadPercentage = 0
      this.statusText = ''
      this.uploadResult = ''
      this.uploadFileName = ''
      this.uploadSuccessOrError = false
      this.fileList = []
      this.firmwarePackage = {}

      const controller = this.uploadAbortController
      this.uploadAbortController = null
      if (controller) {
        controller.abort()
      }

      const upload = this.$refs.firmwareUpload
      if (upload && typeof upload.clearFiles === 'function') {
        upload.clearFiles()
      }
    },
    // 固件上传失败
    uploadError(err) {
      this.isUploading = false
      this.uploadPercentage = 0
      this.$message.error(err)
    },
    // 重置上传相关状态
    resetUploadState({ abort = true } = {}) {
      if (abort && this.uploadAbortController) {
        this.uploadAbortController.abort()
        this.uploadAbortController = null
      }
      this.isUploading = false
      this.uploadPercentage = 0
      this.statusText = ''
      this.fileList = []
      this.uploadSuccessOrError = false
      this.uploadResult = ''
      this.uploadFileName = ''
      this.firmwarePackage = {}
    },
    // 自定义上传函数（OBS 通用上传）
    async onHttpRequest(options) {
      // 新上传开始前清理状态，但不 abort（此时无进行中的任务）
      this.resetUploadState({ abort: false })
      this.isUploading = true
      this.uploadFileName = options.file.name
      this.uploadCancelNotified = false
      this.uploadAbortController = typeof AbortController !== 'undefined' ? new AbortController() : null

      try {
        // 只传 onProgress：工具内会把 MD5(0~15%) + 上传(15~90%) + 合并(100%)拼成连续进度，避免回跳
        const resData = await uploadFileToOBS(
          options.file,
          { obsEnums: 'OTA' },
          {
            onProgress: (percent) => {
              // 已取消则忽略后续进度回调
              if (this.uploadCancelNotified || !this.isUploading) return
              if (percent >= this.uploadPercentage) {
                this.uploadPercentage = percent
              }
            },
            onStatus: (statusText) => {
              if (this.uploadCancelNotified || !this.isUploading) return
              this.statusText = statusText
            },
            signal: this.uploadAbortController ? this.uploadAbortController.signal : undefined
          }
        )

        // 取消后后台任务可能仍返回，忽略成功结果
        if (this.uploadCancelNotified) return

        if (resData) {
          this.fileList = [options.file]
          this.firmwarePackage = {
            ...resData,
            originFileName: resData.originFileName || options.file.name
          }
          this.uploadFileName = this.firmwarePackage.originFileName
          this.uploadResult = 'success'
          this.uploadSuccessOrError = true
          this.$message.success('上传成功')
        } else {
          this.uploadResult = 'error'
          this.uploadSuccessOrError = false
          this.fileList = []
          this.firmwarePackage = {}
          this.$message.error('上传失败，返回数据为空')
        }
      } catch (error) {
        const aborted =
          this.uploadCancelNotified ||
          (error && error.message === '上传已取消') ||
          (error && error.code === 'ERR_CANCELED') ||
          (error && error.name === 'CanceledError') ||
          (error && error.name === 'AbortError')
        if (aborted) {
          // UI 可能已在 cancelUpload 中处理过
          if (!this.uploadCancelNotified) {
            this.uploadCancelNotified = true
            this.$message.info('上传已取消')
          }
          this.uploadResult = ''
          this.uploadFileName = ''
          this.uploadSuccessOrError = false
          this.fileList = []
          this.firmwarePackage = {}
        } else {
          console.error('上传失败:', error)
          this.$message.error((error && error.message) || '上传失败')
          this.uploadResult = 'error'
          this.uploadSuccessOrError = false
          this.fileList = []
          this.firmwarePackage = {}
        }
      } finally {
        this.isUploading = false
        this.uploadAbortController = null
        this.uploadPercentage = 0
        this.statusText = ''
      }
    },
    // 新建固件弹窗关闭
    handleClose(done) {
      if (this.isUploading && this.uploadAbortController) {
        this.uploadAbortController.abort()
        if (!this.uploadCancelNotified) {
          this.uploadCancelNotified = true
          this.$message.info('上传已取消')
        }
      }
      this.dialogVisible = false
      this.formValid = false
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      // 已 abort，这里不再重复 abort
      this.resetUploadState({ abort: false })
      if (typeof done === 'function') {
        done()
      }
    },
    // 提交
    handleSubmit() {
      if (!this.canSubmit) {
        if (this.isUploading) {
          this.$message.warning('固件正在上传中，请稍候')
        }
        return
      }

      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.formValid = false
          return false
        }

        const params = {
          name: this.form.name,
          componentType: this.form.type,
          upgradeChannelNumber: this.form.upgradeChannel,
          customNumber: this.form.customNumbering,
          timeoutTime: this.form.timeoutTime,
          singleTimeout: this.form.singleTimeout,
          description: this.form.remarks,
          addFirmwareBO: {
            ...this.firmwarePackage,
            fileName: this.firmwarePackage.originFileName,
            sign: this.firmwarePackage.md5,
            version: this.form.version,
            description: this.form.description,
            criticalVersionFlag: this.form.criticalVersionFlag,
            isListed: this.form.isListed
          },
          productId: this.form.productId
        }
        this.uploadLoading = true
        addFirmware(params).then((res) => {
          this.tableData = res.data.data.records
          this.total = res.data.data.total
          this.$message.success('上传成功')
          this.handleClose()
          this.uploadLoading = false
          // 返回固件管理列表页调用父组件方法刷新列表
          if (this.pageType === 'firmwareManage') {
            this.queryFirmwareManageList()
          } else if (this.pageType === 'firmwareDetails') {
            this.getFirmwareList()
          }
        }).catch(err => {
          this.uploadLoading = false
          this.$message.error(err.message)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-select {
  width: 100%;
}

::v-deep .upload-demo {
  .el-upload-list {
    display: none;
  }

  .el-upload {
    width: 100%;

    .el-button {
      color: #275fe8;
      width: 100%;
      font-size: 14px;
    }
  }
}

.upload-status-line {
  margin-top: 8px;
  width: 100%;
}

.upload-status-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 6px;
  color: #606266;
  font-size: 12px;
  line-height: 1.4;

  .el-icon-loading {
    margin-right: 6px;
    color: #275fe8;
  }
}

.upload-package-name {
  width: 100%;
  word-break: break-all;
  white-space: normal;
}

.upload-status-step {
  margin-top: 2px;
  color: #909399;
  font-size: 11px;
  line-height: 1.4;
}

.upload-progress-row {
  display: flex;
  align-items: center;
}

.upload-progress-bar {
  flex: 1;
  min-width: 0;
}

.upload-progress-percent {
  flex-shrink: 0;
  margin-left: 10px;
  color: #606266;
  font-size: 12px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.upload-cancel-icon {
  flex-shrink: 0;
  margin-left: 8px;
  color: #909399;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: #f56c6c;
  }
}

.upload-result-line {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.upload-result-name {
  flex: 1;
  min-width: 0;
  color: #606266;
  font-size: 13px;
  line-height: 20px;
  word-break: break-all;
  white-space: normal;
}

.upload-result-icon {
  flex-shrink: 0;
  margin-left: 8px;
  font-size: 16px;
  line-height: 20px;

  &.success {
    color: #67c23a;
  }

  &.error {
    color: #f56c6c;
  }
}
</style>

